<script setup lang="ts">
import { provide } from 'vue';
import { RouterView } from 'vue-router';
import { SetEditingContextFn, type EditingType } from './types';
import EditSlider from '@/components/EditSlider.vue'
// import Navigations from '@/components/Navigations.vue';
// import htmx from 'htmx.org';

//const showNavigation = ref(true);

// const toggleNavigation = () => {
//   showNavigation.value = !showNavigation.value;
// };
const editingId = ref<null | string>( null );
const editingType = ref<null | EditingType>( null );
const showEditingPanel = ref( false )
const editingoverrideUrl = ref<string | null | undefined>(undefined)
const editingHeaderTitle = ref<string | null | undefined>(undefined)

function setEditingContext(
  id: string,
  type: EditingType,
  overrideURL: string | null | undefined,
  headerTitle: string | null | undefined
): void {
  window.dispatchEvent(new CustomEvent('stop-inline-audio'))
  //console.log('setEditingContext', id, type)
  editingId.value = id
  editingType.value = type
  editingoverrideUrl.value = overrideURL
  editingHeaderTitle.value = headerTitle
  showEditingPanel.value = true
}

provide( SetEditingContextFn, setEditingContext );

// provide('showNavigation', showNavigation);
// provide('toggleNavigation', toggleNavigation);



// onMounted(() => {

//   htmx.process(document.querySelector('#nav-list'));
//   console.log(htmx.process)
// });
</script>

<template>
	<div class="flex flex-row overflow-hidden">
			<!-- <div class="py-2 px-4 border-b ">
				<div class="logo-mediscope flex items-center ml-2">
					<img src="/graphics/mediscope.png" alt="" class="h-[20px]">
					<span class="text-primary font-semibold mb-1.5 ml-2">Journal Club (MJC)</span>
				</div>
			</div> -->
			<!-- <aside class="page-sidebar relative" v-if="showNavigation">
			Navigation me HTMX
			<div  id="nav-list" :hx-get="AppConfig.urls.getList" hx-trigger="load"></div>
			</aside> -->
		<div class="w-full relative h-full">
			<EditSlider :id="editingId" :overrideURL="editingoverrideUrl" :type="editingType" :headerTitle="editingHeaderTitle"
				:configcollection="null"
				v-model:visible="showEditingPanel" />
			<RouterView></RouterView>
		</div>
	</div>
</template>
<style scope>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
